<template>
  <div>
    <div class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <vs-tab :label="$t('setup.label.ChargeCode')">
            <charge-code />
          </vs-tab>

          <vs-tab :label="$t('setup.label.ContractPeriod')">
            <Contract />
          </vs-tab>
          <vs-tab :label="$t('setup.label.FeeMaster')">
            <FeeMaster />
          </vs-tab>
          <vs-tab :label="$t('setup.label.TaxMaster')">
            <Tax />
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import VxCard from "@/components/vx-card/VxCard.vue";
import ChargeCode from "./ChargeCode/ChargeCode.vue";
import Contract from "./ContractPeriod/Index.vue";
import FeeMaster from "./FeeMaster/feemasterList.vue";
import Tax from "./Tax/TaxList.vue";
export default {
  data() {
    return {
      activeTab: 0,
    };
  },
  components: {
    VxCard,
    ChargeCode,
    Contract,
    FeeMaster,
    Tax,
  },
};
</script>
